var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Selector/SelectorColor.js",
    _this = this;

import React from 'react';
import { InnerCircle, OuterCircle, Slash } from './style';

var SelectorColor = function SelectorColor(_ref) {
  var hexCode = _ref.hexCode,
      slash = _ref.slash;
  return /*#__PURE__*/React.createElement(OuterCircle, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(InnerCircle, {
    hexCode: hexCode,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 5
    }
  }, slash && /*#__PURE__*/React.createElement(Slash, {
    filledColor: hexCode,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 17
    }
  })));
};

export default SelectorColor;